import React, { useEffect } from 'react';

const BottomBannerAd: React.FC = () => {
  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // Ignore if AdSense is blocked
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', width: '100%', minHeight: 90, margin: '32px 0 0 0' }}
      data-ad-client="ca-pub-1984778779085970"
      data-ad-slot="3409274650"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default BottomBannerAd; 